// extracted by mini-css-extract-plugin
export default {"svgSubtype":"actosSubtype_svgSubtype__98DVn","titleSub":"actosSubtype_titleSub__TsuTS"};